import { Component } from "../extends";

export default () =>
	class Subnav extends Component() {
		events() {
			this.trigger.addEventListener("click", () => this.toggle());
		}

		mounted() {
			this.trigger = this.el.querySelector(".c-subnav__trigger");
			this.content = this.el.querySelector(".c-subnav__content");
			this.contentContainer = this.el.querySelector(
				".c-subnav__container"
			);
		}

		toggle() {
			// Open class list
			this.el.classList.toggle("is-open");

			// Change height
			if (this.el.classList.contains("is-open")) {
				const mobileMenu = document.querySelector(
					".c-site-mobile-menu"
				);
				if (mobileMenu.classList.contains("is-open") === true) {
					this.content.style.height = `${this.contentContainer.clientHeight}px`;
				}
			} else {
				this.content.style.removeProperty("height");
			}
		}
	};
